import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';
import history from 'providers/history';
import Tab from 'components/Tabbar/Tab';
import PlusRoundedIcon from 'components/Icons/PlusRounded';
import CommentIcon from 'components/Icons/Comment';
import TrophyIcon from 'components/Icons/Trophy';
import useSmartPostCreateInitialValues from 'hooks/useSmartPostCreateInitialValues';
import useFeature from 'hooks/useFeature';

const SpecialTab = styled(Tab)`
  position: relative;
  color: #fff;

  &::before {
    content: '';
    position: absolute;
    width: 40px;
    height: 40px;
    background: ${({ theme }) => theme.palette.primary.main};
    border-radius: 50%;
    z-index: -1;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`;

const AddButton = ({ open, onToggle, onClose }) => {

  const { t } = useTranslation(['component']);

  const theme = useTheme();

  const buttonRef = useRef();

  const { channelId } = useSmartPostCreateInitialValues();

  const challengeFeature = useFeature('challenges');

  return (
    <>
      <SpecialTab onClick={onToggle} ref={buttonRef}>
        <PlusRoundedIcon />
      </SpecialTab>

      <Menu
        open={open}
        onClose={onClose}
        anchorEl={buttonRef.current}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}

        slotProps={{
          root: {
            slotProps: {
              backdrop: {
                sx: {
                  zIndex: theme.zIndex.hubBackdrop,
                },
              },
            },
          },
          paper: {
            sx: {
              zIndex: theme.zIndex.hubDrawer,
            },
          },
        }}

        keepMounted
        disableAutoFocusItem
      >
        <MenuItem onClick={() => history.push(`/post/create${channelId ? `?channelId=${channelId}` : ''}`)}>
          <ListItemIcon><CommentIcon /></ListItemIcon>
          <ListItemText>{t('tabbarActions.createNewPost')}</ListItemText>
        </MenuItem>
        {challengeFeature.enabled && challengeFeature.logActivityButton && (
          <MenuItem onClick={() => history.push('/activity/create')}>
            <ListItemIcon><TrophyIcon /></ListItemIcon>
            <ListItemText>{t('tabbarActions.createNewEntry')}</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

AddButton.propTypes = {
  open: PropTypes.bool,
  onToggle: PropTypes.func,
  onClose: PropTypes.func,
};

export default AddButton;
